import TransactionAnalytics from './TransactionAnalytics';
export default function POSReports() { return <TransactionAnalytics kind="pos" title="POS Analytics" />; }
